import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { AuthService } from '../service/auth.service';
import { EventService } from '../service/event.service';
import { ChangeLoginEvent, ProgressBarEvent } from "../service/events";

@Component({
    selector: 'app-progressbar',
    templateUrl: './progressbar.component.html',
    styleUrls: ['./progressbar.component.scss'],
    standalone: false
})
export class ProgressbarComponent implements OnInit {

  loggedIn: boolean = false;
  eventBus: EventService;
  progress: number = 0;
  public _router;
  currentUrl: string;
  actionSection: boolean = false;
  progressDescription: string = '';

  constructor(private authService: AuthService, eventBus: EventService, public router: Router) {
    this.eventBus = eventBus;
    this._router = router;
  }

  ngOnInit() {
    this.eventBus.on(
      ChangeLoginEvent,
      (): void => {
        this.loggedIn = true;
      }
    );

    this.eventBus.on(
      ProgressBarEvent,
      (event): void => {
        this.progress = Math.ceil(event.payload.id);
        this.updateProgressDescription();
      }
    );

    this._router.events.subscribe({
      next: (): void => {
        this.currentUrl = this._router.url;
        if (this.authService.getNavLinks() != null) {
          this.actionSection = this.authService.getNavLinks().find(e => e.routerLink === this.currentUrl) != null;
        }
      }
    });
  }

  private updateProgressDescription(): void {
    this.progressDescription = `${this.progress}% completed other background check information`;
  }
}
